import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer" }

import { watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalComponent',
  props: {
	title: String,
	visible: Boolean,
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const closeModal = (e: Event) => {
  e.preventDefault();
  e.stopPropagation();
  emit('close')
};

watch(() => props, (newValue) => {
	if(newValue.visible){
		document.body.style.overflowY = 'hidden';
	} 
	else{
		document.body.style.overflowY = 'auto';
	}
}, { deep: true, immediate: true });

return (_ctx: any,_cache: any) => {
  return (__props.visible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(props.title), 1),
            _createElementVNode("button", {
              class: "close-button bp-icon-Cross",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal($event)))
            })
          ]),
          _createElementVNode("section", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _createElementVNode("footer", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})